export default "__VITE_ASSET__GnVKvIUW__"